import { MarkedOptions, MarkedRenderer, MARKED_OPTIONS, MarkdownModuleConfig } from 'ngx-markdown';

interface MarkedRendererContext {
  parser?: {
    parseInline: (tokens?: unknown[]) => string;
  };
}

/**
 * Factory function creating custom MarkedOptions.
 * Configures the renderer to ensure all markdown links open in a new tab (target="_blank")
 * and include security attributes (rel="noopener noreferrer").
 */
export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();

  // Custom link renderer to add target="_blank" and rel="noopener noreferrer"
  renderer.link = function (this: MarkedRendererContext | void, token: Parameters<MarkedRenderer['link']>[0]) {
    const text = this?.parser?.parseInline ? this.parser.parseInline(token.tokens) : (token.text || '');
    if (!token.href) {
      return text;
    }
    const titleAttr = token.title ? ` title="${token.title}"` : '';
    return `<a href="${token.href}" target="_blank" rel="noopener noreferrer"${titleAttr}>${text}</a>`;
  };

  return {
    renderer,
  };
}

export const markdownModuleConfig: MarkdownModuleConfig = {
  markedOptions: {
    provide: MARKED_OPTIONS,
    useFactory: markedOptionsFactory,
  },
};
